import { render } from "./LicenseDetailView.vue?vue&type=template&id=f312eece&scoped=true"
import script from "./LicenseDetailView.vue?vue&type=script&lang=js"
export * from "./LicenseDetailView.vue?vue&type=script&lang=js"

import "./LicenseDetailView.vue?vue&type=style&index=0&id=f312eece&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f312eece"]])

export default __exports__